var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{attrs:{"id":"background","fill":_vm.colors[_vm.color]}},[(_vm.type == 'circle')?_c('circle',{attrs:{"transform":_vm.circle.transform,"cx":_vm.circle.cx,"cy":_vm.circle.cy,"r":_vm.circle.r}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }